export default {
    'name': 'kwic',
    'label': 'patent-view.KWIC',
    'getComponent': () => import('./KwicView.vue'),
    'tabIndex': 3,
    'left': true,
    'right': false,
    'singleView': true,
    'compareView': false,
    'exclusiveRoutePath': '/kwic',
};
